'use client'
import type { FC, ReactNode } from 'react'
import NextLink, { type LinkProps } from 'next/link'
import { useParams } from 'next/navigation'
import { LANG } from '@/utils'
import type { TypeLang } from '@/schema'

interface Props extends LinkProps {
  children: ReactNode
  className?: string
  rel?: 'alternate' | 'author' | 'bookmark' | 'help' | 'license' | 'me' | 'next' | 'prev' | 'search' | 'tag'
  role?: 'button' | 'link' | 'menuitem' | 'menuitemcheckbox' | 'menuitemradio' | 'option' | 'tab'
}

const getHref = (href, lang) => {
  const locale = lang ?? LANG
  return ((!lang || lang === LANG) && href === '/') ? href : `/${locale}${href.startsWith('/') ? '' : '/'}${href}`
}


export const Link: FC<Props> = ({ href, children, rel, className, role, ...props }) => {
  const { lang } = useParams() as { lang: TypeLang }
  const hrefWithLang = getHref(href, lang)

  return (
    <NextLink href={hrefWithLang} {...rel && { rel }} {...className && { className }} {...role && { role }} {...props}>
      {children}
    </NextLink>
  )
}
